// extracted by css-extract-rspack-plugin
export default {"rlBox":"rlBox-HS8hMW"};